import React, { useState, useEffect, useRef } from 'react';
import { mdiChevronUp, mdiChevronDown } from '@mdi/js';
import Icon from '@mdi/react';
import { makeApiCall } from "../../../helpers/utils";
import Loader from "../../atoms/icons/loader";
import './ai-summary-box.m.css';

// const TypewriterEffect = ({ htmlString, speed = 20 }) => {
//   const containerRef = useRef(null);
//
//   useEffect(() => {
//     if (!containerRef.current) return;
//
//     const element = containerRef.current;
//     const originalHTML = htmlString;
//     element.innerHTML = '';
//
//     let cursor = 0;
//     let tempHTML = '';
//     const tagStack = [];
//
//     function type() {
//       if (cursor >= originalHTML.length) {
//         element.innerHTML = tempHTML;
//         return;
//       }
//
//       const currentChar = originalHTML[cursor];
//
//       if (currentChar === '<') {
//         const closeTagIndex = originalHTML.indexOf('>', cursor);
//         const tagContent = originalHTML.slice(cursor, closeTagIndex + 1);
//         tempHTML += tagContent;
//
//         if (/^<\/?\w+/.test(tagContent)) {
//           if (!/^<\//.test(tagContent)) {
//             tagStack.push(tagContent);
//           } else {
//             tagStack.pop();
//           }
//         }
//
//         cursor = closeTagIndex + 1;
//       } else {
//         tempHTML += currentChar;
//         cursor++;
//       }
//
//       element.innerHTML = tempHTML;
//       setTimeout(type, speed);
//     }
//
//     type();
//   }, [htmlString, speed]);
//
//   return <div ref={containerRef} />;
// };

const AiSummaryBox = ({ customClass = '', slug = '' }) => {
  const [collapsed, setCollapsed] = useState(true);
  // const [showTypewriter, setShowTypewriter] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState('');
  const [hide, setHide] = useState(false);

  // useEffect(() => {
  //   if (!collapsed) {
  //     setShowTypewriter(true);
  //   }
  // }, [collapsed]);

  useEffect(() => {
    if (!!slug) {
      makeApiCall(`/beeps/get-single-beep-data?slug=${slug.split('/')[1]}`)
        .then(response => {
          if (response?.success && !!response?.data) {
            setLoading(false);
            setData(response?.data);
          } else {
            setLoading(false);
            setHide(true);
          }
        });
    }
  }, []);

  const generateHtmlString = (data) => {
    const points = data.split('\r\n');
    const contentHtml =
      points.length === 1
        ? `<div class='data-para'>${points[0]}</div>`
        : `<ul class='data-points'>${points.map((point) => `<li class='data-point'><div class='data-point-content'>${point}</div></li>`).join('')}</ul>`;

    const footerHtml = `
    <div class="ai-footer">
      <span class="ai-question">Did our AI Summary help ?&nbsp;</span>
      <span class="ai-cta">
        <a href="https://www.ndtv.com/convergence/ndtv/new/complaintform.aspx" target="_blank" rel="noopener noreferrer" class="let-us-know-cta">
          Let us know
        </a>
      </span>
    </div>`;

    return `${contentHtml}${footerHtml}`;
  };

  return (
    <div styleName={`ai-summary-ctx ${customClass} ${hide ? 'hide' : ''}`}>
      <div styleName="ai-summary-inner-ctx">
        <div styleName="header-ctx" onClick={() => setCollapsed(!collapsed)}>
          <div styleName="star-icon" />
          <div styleName="titles">
            <div styleName="title">{collapsed ? 'Show' : ''} Quick Read</div>
            <div styleName="disclaimer">Summary is AI Generated. Newsroom Reviewed</div>
          </div>
          <div styleName="chevron-icon">
            <Icon path={collapsed ? mdiChevronDown : mdiChevronUp} size="24px" color="#8F9DA5" />
          </div>
        </div>
        <div styleName={`data-ctx ${!collapsed ? 'show' : ''}`}>
          <React.Fragment></React.Fragment>
          {!collapsed && (
            <div className='data-ctx-inner' dangerouslySetInnerHTML={{ __html: generateHtmlString(data) }} />
          )}
        </div>
      </div>
      {loading && (
        <div styleName="loader-container-ext">
          <div styleName="loader-container-int">
            <Loader color={'#DADEE1'} />
          </div>
        </div>
      )}
    </div>
  );
};

export default AiSummaryBox;
